export interface LoginInterface {
  TaxRegNo: string;
  Password: string;
}

export interface LoginOTPInterface {
  TaxRegNo: string;
  Otp: string;
}

export interface LoginResponseInterface {
  message: string;
  RequestExp: string;
  TelephoneNo: string;
}

export interface LoginOTPResponseInterface {
  token: string;
}

export enum AUTH {
  TOKEN = 'awqaf-token',
}

export interface VendorDataInterface {
  AttaId: string;
  InfSupplierNumber: string;
  TaxRegNo: string;
  InfSupplierName: string;
  InfTaxRegNoExp: string;
  Status?: string;
  StatusText?: string;
  InfShortName: string;
  InfIsRegistered: boolean;
  InfCommercialRegNo: string;
  InfMainContact: string;
  InfSecondaryContact: string;
  InfEmail: string;
  InfWebsite: string;
  InfActivity: string;
  AddCountry: string;
  AddCity: string;
  AddPostalCode: string;
  AddPostNo: string;
  AddHeadquarters: string;
  ContName: string;
  ContMainContact: string;
  ContSecondaryContact: string;
  ContEmail: string;
  ContLang: string;
  TaxNum: string;
  TaxCerType: string;
  TaxCer: string;
  TaxCerExp: string;
  BankName: string;
  BankAccount: string;
  BankCurr: string;
  BankIban: string;
  BankIbanCopy: string;
  CerZatka: string;
  CerZatkaExp: string;
  CerCommChamber: string;
  CerCommChamberExp: string;
  CerSocial: string;
  CerSocialExp: string;
  CerSaudization: string;
  CerSaudizationExp: string;
  CerSme: string;
  CerSmeExp: string;
  CerEstablishment: string;
  CerCommercialLicense: string;
  CerCommercialLicenseExp: string;
  CerOtherAttachments: string;
  CerOtherAttachments2: string;
  CerOtherAttachments3: string;
  CerOtherAttachments4: string;
}
export interface VendorInterface {
  d: VendorDataInterface;
}

export interface VendorAttaInterface {
  AttaId: string;
  DocId: string;
  DocumentBase64: string;
  DocumentExpiry: string;
  DocumentName: string;
  DocumentType: string;
  TaxRegNo: string;
}

// 000	New  (da new not reached el approval w howa msh hay3raf y login lw new f de msh el mafrood trga3lak)
// 001	Processing  (da in approval w howa msh hay3raf y login lw processing f de msh el mafrood trga3lak)
// 002	Approved
// 003	Rejected (da haytba3tlo mail w aill not be able to login)
// 004	Rejected User Created (da rejected w matloob mno y edid his  data )
export enum VENDOR_STATUS {
  NEW = '000',
  PROCESSING = '001',
  APPROVED = '002',
  REJECTED_NOT_LOGIN = '003',
  REJECTED = '004',
}
